import React from "react";
import Section from "../components/layout/Section";
import {
  Box,
  Button,
  Typography,
} from "@mui/material";

const Donate = () => {

  return (
    <Box sx={{ p: 2.5 }}>
      <Section id="intro" title="Supporting Stylisher">
        <Typography
          variant="caption"
          color="secondary"
          sx={{ mt: -1, mb: 2, display: "block" }}
        >
          Last updated: July 2025
        </Typography>
        <Typography paragraph>
          The Stylisher project is volunteer run and costs around $20 USD monthly at this time. This includes the costs associated with running our discord bot, trade database, server, website and other project integrations. Our team gladly gives our time freely, but if you would like to contribute, please visit our ko-fi linked below! Donations are completely optional and not required to use any of our community resources, but they are always appreciated ❤
        </Typography>

        <Box sx={{ textAlign: 'center', mt: 3 }}>
          <Button
            size="large"
            href="https://ko-fi.com/lebronnc"
            variant="contained"
          >
            visit us on ko-fi!
          </Button>
          <Typography
            variant="caption"
            color="secondary"
            sx={{ mt: 1, mb: 2, display: "block" }}
          >
            Huge thank you to everyone who has supported us!
          </Typography>
        </Box>

      </Section>
    </Box>
  );
};

export default Donate;